<template>
  <div class="pc-list" ref="list">
    <!-- <NewCompetitionWorkSearch @search="search" /> -->
    <h1>人员信息</h1>
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <!-- <button @click="deleteUser">删除</button> -->
          <!-- <span></span> -->
          <!-- <button @click="updateUser">修改</button> -->
          <!-- <span></span> -->
          <!-- <button @click="exportWork">导出数据</button> -->
          <button @click="addUser">添加</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="competitionWorkList"
    >
      <el-table-column
        fixed="left"
        prop="id"
        sortable="custom"
        label="人员ID"
        width="160"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.id ? scope.row.id : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="contestants_type"
        label="人员类型"
        width="100"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.contestants_type ? scope.row.contestants_type : "暂无"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="photo_src"
        label="人员图片"
        width="100"
        fixed="left"
      >
        <template slot-scope="scope">
          <div class="eltable-img">
            <img v-if="scope.row.photo_src" :src="scope.row.photo_src" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="人员名称" width="120">
        <template slot-scope="scope">
          <div>
            {{ scope.row.name ? scope.row.name : scope.row.name }}
            <br />
            {{
              scope.row.name_pinyin
                ? scope.row.name_pinyin
                : scope.row.name_pinyin
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户名" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.username ? scope.row.username : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="university" label="大学" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.university ? scope.row.university : "暂无" }}
          </div>
        </template>
      </el-table-column>
            <el-table-column prop="college" label="学院" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.college ? scope.row.college : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="id_card_src" label="证明照片" width="100">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img v-if="scope.row.id_card_src" :src="scope.row.id_card_src" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="student_id_src" label="学号" width="100">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img
              v-if="scope.row.student_id_src"
              :src="scope.row.student_id_src"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="email" label="邮箱" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.email ? scope.row.email : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.phone ? scope.row.phone : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="company" label="公司" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.company ? scope.row.company : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="city" label="城市" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.city ? scope.row.city : "暂无" }}
          </div>
        </template>
      </el-table-column>

      <el-table-column width="120">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="updateUser(scope.row)">
            修改
          </button>
        </template>
      </el-table-column>
      <el-table-column width="120">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="deleteUser(scope.row)">
            删除
          </button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      class="designerDialog"
      :visible.sync="dialogFormVisible"
      width="40%"
    >
      <el-form label-width="100px">
        <el-form-item label="参赛者类型">
          <el-input
            v-model="userDetail.contestants_type"
            placeholder="请输入参赛者类型"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="图片">
          <UploadImage
            :img="userDetail.photo_src"
            :width="200"
            :height="160"
            @getUploadImage="getUploadPhotoImage"
          ></UploadImage>
        </el-form-item>
        <el-form-item label="人员名称">
          <el-input
            v-model="userDetail.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="城市">
          <el-input
            v-model="userDetail.city"
            placeholder="请输入城市"
          ></el-input>
        </el-form-item>
        <el-form-item label="大学">
          <el-input
            v-model="userDetail.university"
            placeholder="请输入大学"
          ></el-input>
        </el-form-item>
        <el-form-item label="学院">
          <el-input
            v-model="userDetail.college"
            placeholder="请输入学院"
          ></el-input>
        </el-form-item>
        <el-form-item label="证明照片">
          <UploadImage
            :img="userDetail.id_card_src"
            :width="200"
            :height="160"
            @getUploadImage="getUploadIdImage"
          ></UploadImage>
        </el-form-item>
        <el-form-item label="学号">
          <UploadImage
            :img="userDetail.student_id_src"
            :width="200"
            :height="160"
            @getUploadImage="getUploadStudentImage"
          ></UploadImage>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="userDetail.phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input
            v-model="userDetail.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitDialog(userDetail)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="competitionWorkList ? competitionWorkList.length > 0 : ''"
      :pagination="pagination_options"
      @goPage="goPage"
    />
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import DeleteHint from "@/components/template/DeleteHint";
import UploadImage from "../../../componentSet/uploadImage.vue";
import {
  competitionWorkDetail_Api,
  contestantsDetail_Api,
  updateContestantsDetail_Api,
  deleteContestantsDetail_Api,
} from "@/apis/competition.api";
export default {
  components: {
    Pagination,
    DeleteHint,
    UploadImage
  },
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      dialogFormVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "+works_code",
        competition_id: null,
      },
      userDetail: {
        works_id: null,
        contestants_type: null,
        name: null,
        phone: null,
        contestants_id:null,
        city:null,
        college:null,
        email:null,
        photo_src:null,
        student_id_src:null,
        id_card_src:null,
        username:null,
        university:null
      },
      contestants_id: null,
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      isSelectAll: false,
      competitionWorkList: [],
      checked: [],
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      // this.competitionWorkDetail.id = this.$route.query.id;
      this.getCompetitionWorkListByRules(this.searchRules);
    }
  },
  methods: {
    getCompetitionWorkListByRules() {
      competitionWorkDetail_Api(+this.$route.query.id)
        .then((res) => {
          console.log(res.data);
          this.competitionWorkList = res.data.contestants_data;
          this.$set(
            this.pagination_options,
            "total",
            res.data.contestants_data.length
          );
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    addUser() {
      this.dialogFormVisible = true;
      this.contestants_id = null;
      this.userDetail = {

      };
    },
    deleteUser(item) {
      console.log(item);
      this.contestants_id = item.id;
      this.deleteDialogVisible = true;
    },
    updateUser(item) {
      console.log(item);
      this.userDetail = {
        contestants_type: item.contestants_type,
        name: item.name,
        phone: item.phone,
        contestants_id:item.id,
        city:item.city,
        college:item.college,
        email:item.email,
        photo_src:item.photo_src,
        student_id_src:item.student_id_src,
        id_card_src:item.id_card_src,
        username:item.username,
        university:item.university
      };
      this.contestants_id = item.id;
      this.dialogFormVisible = true;
    },
    isDelete() {
      deleteContestantsDetail_Api({ contestants_id: this.contestants_id }).then(
        (res) => {
          if (res.code == 205) {
            this.$global.success(this, "删除成功！");
            this.deleteDialogVisible = false;
            this.getCompetitionWorkListByRules(this.searchRules);
          } else {
            this.$global.error(this, "删除失败！");
            return;
          }
        }
      );
    },
    submitDialog() {
      this.userDetail.works_id = +this.$route.query.id;
      if (this.contestants_id != null) {
        updateContestantsDetail_Api(this.userDetail).then((res) => {
          if (res.code == 205) {
            this.$global.success(this, "修改成功");
            this.dialogFormVisible = false;
            this.getCompetitionWorkListByRules(this.searchRules);
          } else {
            this.$global.error(this, "修改失败");
            return;
          }
        });
      } else {
        contestantsDetail_Api(this.userDetail).then((res) => {
          if (res.code == 205) {
            this.$global.success(this, "创建成功");
            this.dialogFormVisible = false;
            this.getCompetitionWorkListByRules(this.searchRules);
          } else {
            this.$global.error(this, "创建失败");
            return;
          }
        });
      }
    },
    getUploadPhotoImage(img_url) {
      this.userDetail.photo_src = img_url;
    },
    getUploadIdImage(img_url) {
      this.userDetail.id_card_src = img_url;
    },
    getUploadStudentImage(img_url) {
      this.userDetail.student_id_src = img_url;
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
        console.log(this.searchRules.order);
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "+works_code";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getCompetitionWorkListByRules(data);
      this.pagination_options.page = 1;
    },

    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getCompetitionWorkListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      // if (!formData.competition_id) {
      data.competition_id = +this.$route.query.id;
      // }
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.pre_audit) {
        data.pre_audit = parseInt(formData.pre_audit);
      }
      if (formData.name_keywords) {
        data.name_keywords = formData.name_keywords;
      }
      if (formData.works_code) {
        data.works_code = formData.works_code;
      }

      return data;
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getCompetitionWorkListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
/deep/ .el-upload__tip{
  margin-top: -5px
}
/deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/NewCompetitionWorkDetailTable.vue